import BreadCrumb from "@componentsShared/BreadCrumb";
import { HeroArea } from "./components/HeroArea/HeroArea";
import TrendsList from "./components/TrendsList/TrendsList";
import Pagination from "@/pages/trends/components/Pagination/Pagination";
import stl from "./TrendsComponent.module.css";
import {useTranslation} from "@i18n";

const TrendsComponent = ({
  trendsList,
  totalPages,
  currentPage
}) => {
  const {t} = useTranslation();
  return (
    <>
      <div className={stl.mainContainer}>
        <BreadCrumb
          
          className={stl.brdCrmb}
          links={[
            {
              title: t("سيارة ترند", { ns: "web_common" }),
            }
          ]}
        />
        <HeroArea />
        {trendsList.length ? (
          <TrendsList
            trendsList={trendsList}
            currentPage={currentPage}
          />
        ) : null }
        {totalPages > 1 && (
          <Pagination
            pageCount={totalPages}
            currentPage={currentPage}
          />
        )}
      </div>
    </>
  );
};

export default TrendsComponent;
